import { BetType, IConfirmedBet } from '../types';
import { SLOTS, NO_COMMISSION_BET_TYPE } from 'types';

export const confirmedBetsToObj = (confirmedBets: IConfirmedBet[]): BetType =>
  confirmedBets.reduce((acc, { bet, type }: IConfirmedBet) => {
    const slotType: SLOTS = (type === NO_COMMISSION_BET_TYPE ? SLOTS.banker : type) as SLOTS;
    return { ...acc, [slotType]: bet };
  }, {} as BetType);

export const betsObjToConfirmedBets = (
  bets: BetType,
  isCommissionMode: boolean,
): IConfirmedBet[] => {
  return Object.entries(bets).map(([type, bet]) => {
    const betType = type === SLOTS.banker && !isCommissionMode ? NO_COMMISSION_BET_TYPE : type;
    return { type: betType, bet };
  });
};

export const filterEmptyBets = (bets: IConfirmedBet[]): IConfirmedBet[] => {
  return bets.filter(({ bet }) => bet > 0);
};

export const fillAllSlots = (bets: IConfirmedBet[]): IConfirmedBet[] => {
  const allSlots = Object.values(SLOTS);

  return allSlots.map((slot) => {
    const existingBet = bets.find(({ type }) => {
      if (slot === SLOTS.banker && type === NO_COMMISSION_BET_TYPE) {
        return true;
      }
      return type === slot;
    });
    return { type: slot, bet: existingBet?.bet || 0 };
  });
};
